<template>
  <div class="common-panel" v-if="currItem.questions">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content">
      <!-- 选项 -->
      <div class="panel-content-options">
        <div class="question-options-item" v-for="option in currItemOptions" :key="option.index">
          <div class="item-key">{{ option.key }}</div>
          <div class="item-content">
            <img :src="baseUrl + option.content + '?width=300'" alt="" />
          </div>
        </div>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="item in filterQuestionList" :key="item.index">
          <div class="question-item-stem">
            <div :class="[currItem.screen_text[0].type == 'text' ? 'stem-index-nopinyin' : 'stem-index']">
              {{ item.is_example ? $t("hsk_example") : item.index }}.
            </div>
            <div class="stem-content" v-for="text in item.screen_text" :key="text.content">
              <PhoneticText :showPinyin="true" :originData="text.content" :baseStyles="textBlackStyles"> </PhoneticText>
            </div>
          </div>
          <div class="question-item-options">
            <div
              v-for="option in item.answers"
              :key="`${item.index}_${option.index}`"
              :class="[
                'question-item-options-item',
                {
                  selected: option.selected || (item.is_example && option.correct),
                  success: !isExamMode && option.correct,
                  error: !isExamMode && option.selected && !option.correct,
                },
              ]"
              :data-correct="option.correct ? 1 : 0"
              @click="clickQuestionChoice($event, item, option)"
            >
              {{ String.fromCharCode(64 + parseInt(option.index)) }}
            </div>
          </div>
          <div
            class="panel-content-result result-correct"
            v-if="!isExamMode && !item.is_example && item.myAnswerText == item.successAnswerText"
          >
            <p class="correct-tips">
              {{ $t("textbook_chioce_word_text_correct_tip") }}
            </p>
            <div class="correct-box" v-if="item.analysisText">
              <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
              <p class="correct-box-answer">
                {{ item.analysisText }}
              </p>
            </div>
          </div>

          <div
            class="panel-content-result result-error"
            v-if="!isExamMode && !item.is_example && item.myAnswerText != item.successAnswerText"
          >
            <p class="error-tips">
              {{ $t("textbook_chioce_word_text_error_tip") }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t("hsk_your_answer") }}{{ item.myAnswerText }}</div>
              <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ item.successAnswerText }}</p>
            </div>
            <div class="correct-box" v-if="item.analysisText">
              <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
              <p class="correct-box-answer">
                {{ item.analysisText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneticText from "@/components/ui/phoneticText";
import QuestionDescription from "@/components/hsk/questionDescription";

export default {
  components: {
    PhoneticText,
    QuestionDescription,
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案
      currCorrectAnswer: [1, 2, 3],
      // 是否已提交
      isSubmit: false,
      // 是否页面事件禁用
      isDisabled: false,
      changeBtn: false,
    };
  },
  computed: {
    currItemOptions() {
      let array = [];
      array = this.currItem.questions[0].answers.map((item, index) => {
        return {
          index: item.index,
          key: String.fromCharCode(64 + parseInt(item.index)),
          content: item.content,
        };
      });
      return array;
    },
    //初始黑色
    textBlackStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: "#3F4651",
        // 拼音文本字体大小
        pinyinFontSize: "10px",
        // 拼音文本 行高
        pinyinLineHeight: "14px",
        // 汉字文本初始颜色
        originHzColor: "#3E4651",
        // 拼音文本字体大小
        hzFontSize: "15px",
        // 汉字文本 行高
        hzLineHeight: "15px",
        // 行文 间距(下方间距)
        writingSpacing: "0px",
        // 分词间距
        wordSpacing: "10px",
      };
    },
    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    filterQuestionList() {
      let questionsList = this.currItem.questions;
      // let array = []
      // //去除例题
      // array = questionsList.filter(function (item) {
      //   return !item.is_example
      // })
      //根据当前语言显示分析
      questionsList
        .filter(function (item) {
          return !item.is_example;
        })
        .map((item, index) => {
          item.analysisText =
            (item.analysis && item.analysis[this.language]) || (item.analysis && item.analysis["zh"]) || "";
          if (this.currItem.answer && this.currItem.answer.length > 0 && !this.changeBtn) {
            for (let i = 0; i < item.answers.length; i++) {
              if (item.answers[i].index == this.currItem.answer[index]) {
                item.answers[i].selected = true;
                item.myAnswerText = item.answers[i].flag;
              } else {
                item.answers[i].selected = false;
              }
              if (item.answers[i].correct) {
                item.successAnswerText = item.answers[i].flag;
              }
            }
          }
        });

      this.changeBtn = false;
      return questionsList;
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    baseUrl: {
      type: String,
      default: "",
    },
  },
  watch: {},
  methods: {
    // 小题选项点击事件
    clickQuestionChoice(event, question, option) {
      console.log(question);
      if (question.is_example) {
        return;
      }
      if (!this.isExamMode) {
        return;
      }
      event.currentTarget.classList.add("selected");
      const isCorrect = parseInt(event.currentTarget.dataset.correct);

      let questions = this.currItem.questions.map((item) => {
        if (item.index === question.index) {
          let questionTemp = {
            ...item,
            ansId: option.index, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          };
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.index === option.index) {
              return {
                ...item1,
                selected: true,
              };
            } else {
              return {
                ...item1,
                selected: false,
              };
            }
          });

          return {
            ...questionTemp,
          };
        } else {
          return {
            ...item,
          };
        }
      });

      this.changeBtn = true;
      this.currItem.questions = questions;
      Object.assign(this.currItem.questions, questions);
      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      };
      console.log(ansObj);
      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-panel {
  position: relative;
  padding-top: 30px;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .panel-content {
    min-height: 540px;

    // 选项列表
    &-options {
      padding: 30px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .question-options-item {
        width: 195px;
        height: 110px;
        margin-bottom: 20px;
        margin-right: 30px;
        border-radius: 5px;
        position: relative;

        .item-key {
          width: 46px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 4px 0px 4px 0px;
          position: absolute;
          left: 0px;
          top: 0px;
        }
        .item-content {
          img {
            width: 195px;
            height: 110px;
            border-radius: 5px;
            object-fit: contain;
          }
        }
      }
    }

    // 套题详情
    &-details {
      padding: 0 30px;

      .question-item {
        padding: 20px 0;
        border-top: 1px solid #f2f3f7;

        &-stem {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          width: 100%;
          flex-wrap: wrap;
          .stem-index {
            margin-right: 10px;
            color: #c4c9d3;
            margin-top: 15px;
          }
          .stem-index-nopinyin {
            margin-right: 10px;
            color: #c4c9d3;
            line-height: 15px;
            margin-top: 1px;
          }
          .stem-content {
            ::v-deep.phtContent > .normal_pht > .pht_single > .pinyin > span {
              color: #3f4651 !important;
            }
            ::v-deep.phtContent > .normal_pht > .pht_single > .pinyin > span > span {
              color: #3f4651 !important;
            }
            ::v-deep.phtContent > .normal_pht > .pht_single > .hz > span {
              color: #3f4651 !important;
            }
            ::v-deep.phtContent > .normal_pht > .pht_single > .hz > span > span {
              color: #3f4651 !important;
            }
          }
        }
        &-options {
          margin-top: 20px;

          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          &-item {
            cursor: pointer;
            width: 42px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            background-color: rgba(242, 243, 247, 1);
            border-radius: 2px;
            margin-right: 20px;
            color: rgba(57, 61, 70, 1);
            font-size: 14px;

            &.selected {
              border: 2px solid #faae56;
              background: #ffffff;
            }
            &.success {
              background: #ffffff; // 设置白色背景
              border: 1px solid rgba(9, 203, 160, 1);
              color: #09cba0;
            }
            &.error {
              border: 1px solid #fc5a5a;
              color: #fc5a5a;
              background: #ffffff;
            }
          }
        }
      }
    }

    // 选词填空选项列表
    &-answers {
      margin-top: 30px;
      .list-answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-answer {
        cursor: pointer;
        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 380px;
        height: 58px;
        line-height: 58px;
        font-size: 18px;
        margin-top: 20px;

        color: rgba(63, 70, 81, 1);
        background: rgba(242, 243, 247, 1);
        border-radius: 5px;
        box-sizing: border-box;

        .text {
          overflow: hidden;
          text-overflow: ellipsis;

          ::v-deep.pht_single {
            margin-bottom: 10px !important;
          }
        }

        &:after {
          position: absolute;
          content: "";
          width: 16px;
          height: 16px;
          right: -24px;
          top: 50%;
          transform: translateY(-50%);
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: cover;
        }

        &.success {
          background: #ffffff; // 设置白色背景
          border: 1px solid rgba(9, 203, 160, 1);
          color: #09cba0;
        }

        &.error {
          background: #ffffff;
          border: 1px solid #fc5a5a;
          color: #fc5a5a;
        }
      }
    }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
